import { RouterPage } from 'lib/navigation/consts'

export const getPathnameAsLocation = (pathname: string) => {
  if (pathname.includes(RouterPage.clientManager)) {
    return 'client-manager' as const
  }

  if (pathname.includes(RouterPage.dashboard)) {
    return 'dashboard' as const
  }

  if (pathname.includes(RouterPage.inbox)) {
    return 'inbox' as const
  }

  if (pathname.includes(RouterPage.payables)) {
    return 'bills' as const
  }

  if (pathname.includes(RouterPage.repayments)) {
    return 'repayments' as const
  }

  if (pathname.includes(RouterPage.payments)) {
    return 'payments' as const
  }

  if (pathname.includes(RouterPage.purchaseOrders)) {
    return 'purchase-orders' as const
  }

  if (pathname.includes(RouterPage.receipts)) {
    return 'shipping-receipts' as const
  }

  if (pathname.includes(RouterPage.catalog)) {
    return 'catalog' as const
  }

  if (pathname.includes(RouterPage.vendors)) {
    return 'vendors' as const
  }

  if (pathname.includes(RouterPage.receivables)) {
    return 'invoices' as const
  }

  if (pathname.includes(RouterPage.purchasers)) {
    return 'customers' as const
  }

  if (pathname.includes(RouterPage.docsAndReports)) {
    return 'docs-and-reports' as const
  }

  if (pathname.includes(RouterPage.syncCenter)) {
    return 'sync-center' as const
  }

  return null
}
